import React from "react";
import Block from "../Block";
import styles from "./Blocks.module.scss";

const BannerBlock = ({ block }) => {
  return (
    <Block className={styles.bannerBlock}>
      {block.bannerText && <h2>{block.bannerText}</h2>}
    </Block>
  );
};

export default BannerBlock;
